// deps
import React, { ReactElement, useMemo } from "react";

// components
import PaymentGroupContainer from "../components/Container";
import PaymentGroupTitle from "../components/Title";
import Cred from "@payment-ui/components/payment-method/cred";

// helpers
import { isEmpty } from "@swiggy-private/payment-core";
import {
    getPaymentMethods,
    isPaymentMethodSelected,
    generatePaymentMethodId,
    getPaymentGroupDisplayName,
    isPaymentGroupEnabled,
    getPaymentGroupDisableMessage,
    getPaymentGroupIconUrl,
} from "@payment-ui/helpers/Payment";

// interfaces
import { CredPayPaymentGroup } from "@payment-ui/interfaces/CredPay";

// data testids
import { PAYMENT_GROUP_TEST_IDS } from "@swiggy-private/payment-test-ids";
import styles from "../PaymentGroup.v4.scss";

export default function CredPayGroup(props: CredPayPaymentGroup): ReactElement | null {
    const paymentMethods = useMemo(() => getPaymentMethods(props), [props]);
    const isGroupEnabled = useMemo(() => isPaymentGroupEnabled(props.paymentData), [props.paymentData]);

    if (isEmpty(paymentMethods)) {
        return null;
    }
    return (
        <PaymentGroupContainer>
            {!props.hideGroupTitle && (
                <PaymentGroupTitle
                    title={getPaymentGroupDisplayName(props.paymentData)}
                    disableMessage={getPaymentGroupDisableMessage(props.paymentData)}
                    data-testid={PAYMENT_GROUP_TEST_IDS.TITLE.CRED}
                    groupIcon={getPaymentGroupIconUrl(props.paymentData)}
                />
            )}
            <div className={styles.paymentGroupContainer}>
                {paymentMethods.map(paymentMethod => {
                    const id = generatePaymentMethodId(paymentMethod);
                    return (
                        <Cred
                            key={paymentMethod.displayName}
                            id={id}
                            methodData={paymentMethod}
                            paymentActions={props.paymentActions}
                            isPaymentGroupEnabled={isGroupEnabled}
                            selected={isPaymentMethodSelected(props.selectedPaymentId, id)}
                            bannerText={props.bannerText}
                            isEligible={props.isEligible}
                            isSdkAvailable={props.isSdkAvailable}
                            isOfferLoading={props.isOfferLoading}
                        />
                    );
                })}
            </div>
        </PaymentGroupContainer>
    );
}
